var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"svgobject"},[_c('object',{attrs:{"alt":"Layout","data":_vm.location,"type":"image/svg+xml"}},[_vm._v(" Browser not compatible ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }